"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_MasterSharpshooter_OnDamageDealtEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
let Effect_MasterSharpshooter_OnDamageDealtEventHandlerScript = class Effect_MasterSharpshooter_OnDamageDealtEventHandlerScript {
    run(sequence, container, handler, event) {
        if (container.isDeceased(event.args.targetId)) {
            return;
        }
        else if (event.args.fromDoT) {
            return;
        }
        else if (event.args.damage.amount <= 0) {
            return;
        }
        container.applyDebuff({
            sequence,
            attackerId: event.subject,
            targetId: event.args.targetId,
            duration: Duration_1.Duration.Ticks(4),
            effect: new core_1.BleedingEffectArgs("Power", 10)
        });
    }
};
Effect_MasterSharpshooter_OnDamageDealtEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_MasterSharpshooter_OnDamageDealt")
], Effect_MasterSharpshooter_OnDamageDealtEventHandlerScript);
exports.Effect_MasterSharpshooter_OnDamageDealtEventHandlerScript = Effect_MasterSharpshooter_OnDamageDealtEventHandlerScript;
